import Bonus from "../../model/bonus/Bonus";
import Page from "../framework/Page";
import View from "../framework/View";

const DISPLAY_STATE_UNSET = -1;
// const DISPLAY_STATE_NOT_ACTIVATED_READY = 0;
// const DISPLAY_STATE_NOT_ACTIVATED_NOT_READY = 1;
// const DISPLAY_STATE_ACTIVATED = 2;

export default class ActiveBonusView extends View {
    /**
     * @param {string} parentId 
     * @param {string} elementId 
     * @param {Bonus} bonus
     */
    constructor(parentId, elementId, bonus) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {Bonus}
         */
        this.bonus = bonus;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {HTMLElement}
         */
        this.activeProgressElement = null;
        // /**
        //  * @type {HTMLElement}
        //  */
        // this.coolDownProgressElement = null;

        /**
         * @type {HTMLElement}
         */
        this.titleElement = null;
        /**
         * @type {HTMLElement}
         */
        this.descriptionElement = null;

        /**
         * @type {string}
         */
        this.displayedTitle = null;
        /**
         * @type {string}
         */
        this.displayedDescription = null;


        /**
         * 0 - Not actived, but ready to be activated
         * 1 - Not activated and not ready to be activated
         * 2 - Activated
         * @type {number}
         */
        this.displayState = DISPLAY_STATE_UNSET;

    }

    /**
     * @override
     */
    initializeView() {
        // The skill view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('ActiveSkillView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'active-skill-button-outer-active');

        this.activeProgressElement = Page.createElement('div', this.mainElement, null, 'active-skill-panel-activated');
        //this.coolDownProgressElement = Page.createElement('div', this.mainElement, null, 'active-skill-panel-cool-down');

        //Page.hideElement(this.activeProgressElement);
        //Page.hideElement(this.coolDownProgressElement);

        const bodyElement = Page.createElement('div', this.mainElement, null, 'active-skill-button-body');

        const iconElement = Page.createElement('div', bodyElement, null, 'icon-container');

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', bodyElement, null, 'active-skill-title-description-container');

        // <img src="images/miner_icon_51x48.png"/>
        const imgElement = Page.createElement('img', iconElement, null, null);
        imgElement.src = this.bonus.spriteFileName; 

        // By default make the title use the 'single-row' style
        this.titleElement = Page.createElement('div', titleDescriptionContainer, null, 'skill-panel-row1-title');
        this.titleElement.innerHTML = '';

        this.descriptionElement = Page.createElement('div', titleDescriptionContainer, null, 'skill-panel-row2-description');
        this.descriptionElement.innerHTML = '';

        //////////////////////////////////////
        // Setup initial visibility
        //////////////////////////////////////

        this.setInitialVisibility(true);

        // //////////////////////////////////////
        // // Button Click
        // //////////////////////////////////////

        // const thisRef = this;
        // this.mainElement.onclick = function() {
        //     if (!thisRef.bonus.isActivationReady()) {
        //         return;
        //     }

        //     thisRef.bonus.onSkillActivation();
        // };

        super.initializeView();
    }

    // /**
    //  * Updates the user interface to reflect the data in the model.
    //  */
    // updateView() {
    //     //////this.setViewVisible(this.skill.isSkillUnlocked());

    //     super.updateView();
    // }

    /**
     * @override
     */
    updateViewContents() {
        const title = this.bonus.getTitle();
        if (title !== this.displayedTitle) {
            this.displayedTitle = title;
            this.titleElement.innerHTML = title;
        }

        const description = this.bonus.getDescription();
        if (description && description !== this.displayedDescription) {
            this.displayedDescription = description;
            if (this.descriptionElement) {
                this.descriptionElement.innerHTML = description;
            }
        }

        // Display States:
        // 0 not activated - ready to be activated
        // 1 not activated - not ready to be activated
        // 2 activated

        // const displayState = this.getDisplayState();
        // if (this.displayState !== displayState) {
        //     this.displayState = displayState;

        //     if (displayState === DISPLAY_STATE_ACTIVATED) {
        //         this.mainElement.className = 'active-skill-button-outer-active';

        //         Page.showElement(this.activeProgressElement);
        //         //Page.hideElement(this.coolDownProgressElement);
        //     }
        //     else if (displayState === DISPLAY_STATE_NOT_ACTIVATED_READY) {
        //         this.mainElement.className = 'active-skill-button-outer';
        //         Page.hideElement(this.activeProgressElement);
        //         //Page.hideElement(this.coolDownProgressElement);
        //     }
        //     else if (displayState === DISPLAY_STATE_NOT_ACTIVATED_NOT_READY) {
        //         // Cool Down
        //         this.mainElement.className = 'active-skill-button-outer-not-purchasable';
        //         Page.hideElement(this.activeProgressElement);
        //         //Page.showElement(this.coolDownProgressElement);
        //     }
        //     else {
        //         console.log('ActiveSkillView.updateViewContents() Unexpected display state=' + displayState);
        //     } 
        // }

        // if (displayState === DISPLAY_STATE_ACTIVATED) {
            const percent = this.bonus.getActivationPercent();
            this.activeProgressElement.style.width = percent + '%';
        // }
        // else if (displayState === DISPLAY_STATE_NOT_ACTIVATED_NOT_READY) {
        //     const coolDownPercent = 100 - this.bonus.getCoolDownPercent();
        //     this.coolDownProgressElement.style.width = coolDownPercent + '%'; 
        // }
    }

    // /**
    //  * @private
    //  * @returns {number}
    //  */
    // getDisplayState() {
    //     return DISPLAY_STATE_ACTIVATED;
    //     // if (this.bonus.isActivated()) {
    //     //     return DISPLAY_STATE_ACTIVATED;
    //     // }
    //     // else if (this.bonus.isActivationReady()) {
    //     //     return DISPLAY_STATE_NOT_ACTIVATED_READY;
    //     // }
    //     // else {
    //     //     return DISPLAY_STATE_NOT_ACTIVATED_NOT_READY;
    //     // }
    // }

}